import { UICorePlugin } from "../../../../lib/Plugin";
import { loadDesignerDefaultReplaceComponentHook } from "../../../../lib/designer/utils/defaultReplaceComponent";
export class FitDataReplacePlugin extends UICorePlugin {
  install(uc) {
    loadDesignerDefaultReplaceComponentHook(uc);
  }
}